import React, { useState, useCallback } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { GetFormatedDateWithTime } from '../../../../../common/Utils'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import TransactionSearchFormResult from "../maintabs/transaction/TransactionSearchFormResult";
import TransactionSearchForm from "../maintabs/transaction/TransactionSearchForm";
const ReceiptTransactions = (props) => {
    const orderStatus = '0';
    const getDataUrl = "wm/TransactionManagement/GetTransactionHeader";
    const [dataSource, setDataSource] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [pageTitle, setPageTitle] = useState('Transactions (Receipts)');
    var accessToken = props.oidc.user.access_token;
    const GetGridData = (accessToken, url, formFields) => {
        const resultData = createStore({
            key: 'rowid',
            loadParams:
            {
                CustomerId: function () {
                    return formFields.R_CUSTOMER;
                },
                Recordtype: function () {
                    return 'R';
                },
                Transactiontype: function () {
                    return 'R';
                },
                TransactionDateFrom: function () {
                    return GetFormatedDateWithTime(formFields.TransactionDateFrom);
                },
                CarrierId: function () {
                    return formFields.R_CARRIER;
                },
                TransactiondateTo: function () {
                    return GetFormatedDateWithTime(formFields.TransactionDateTo);
                },
                TransactiondateTo: function () {
                    return GetFormatedDateWithTime(formFields.TransactionDateTo);
                },
                CarrierName: function () {
                    return formFields.CarrierName;
                },
                DeliveryDateFrom: function () {
                    return GetFormatedDateWithTime(formFields.DeliveryDateFrom);
                },
                Transactionnumber: function () {
                    return formFields.TRANSACTIONNUMBER;
                },
                DeliverydateTo: function () {
                    return GetFormatedDateWithTime(formFields.DeliveryDateTo);
                },
                transStatus: function () {
                    return 3;
                },
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };
    const searchData = (formFields) => {
        var resultData = GetGridData(accessToken, getDataUrl, formFields);
        console.log(resultData);
        setDataSource(resultData);
    };
    const handleRowSelected = useCallback((rowId) => setSelectedRowId(rowId), []);
    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <TransactionSearchForm pageTitle={pageTitle} searchData={searchData} selectedRowId={selectedRowId} />
                        <TransactionSearchFormResult data={dataSource} gridKey={"435C746B-4703-4729-B93B-D41A2964E738"} onRowSelected={handleRowSelected} transTabColoring={props.transTabColoring} />
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ReceiptTransactions);